"use strict";

import { MenuItem, Select } from "@mui/material";
import React from "react";

import { getLanguageName } from "../../utils/generalFunctions";

/**
 * The language picker on the Actions page rows (translation, takes, lip sync,
 * remux). It lives outside the page component on purpose: a component defined
 * inside a render is a new type on every render, so React remounts it and an
 * open menu closes. The Actions page re-renders every 10 seconds when it
 * refreshes task statuses.
 */
const LangSelect = ({ value, onChange, languages, placeholder = "Choose language" }) => (
    <Select size="small" value={value} onChange={(e) => onChange(e.target.value)} displayEmpty>
        <MenuItem value="" disabled>
            {placeholder}
        </MenuItem>
        {languages?.map((language, index) => (
            <MenuItem key={index} value={language}>
                {getLanguageName(language)}
            </MenuItem>
        ))}
    </Select>
);

export default LangSelect;
